import { useTranslation } from "react-i18next";
import { NeuButton, NeuSelect } from "../../components/neu/Neu";
import { DateInput } from "../../components/neu/DateInput";

export const AuditFilters = ({ filters, setFilters, actions, csvUrl }) => {
  const { t } = useTranslation();
  const set = (key) => (e) => setFilters((f) => ({ ...f, [key]: e.target.value }));

  return (
    <div className="mt-4 grid gap-3 sm:grid-cols-4" data-testid="audit-filters">
      <div>
        <p className="label-xs mb-1">{t("audit.action")}</p>
        <NeuSelect data-testid="audit-action" value={filters.action} onChange={set("action")}>
          <option value="">{t("audit.allActions")}</option>
          {actions.map((a) => (
            <option key={a} value={a}>
              {t(`audit.actions.${a}`, a)}
            </option>
          ))}
        </NeuSelect>
      </div>
      <div>
        <p className="label-xs mb-1">{t("audit.from")}</p>
        <DateInput testId="audit-from" value={filters.date_from} onChange={(v) => setFilters((f) => ({ ...f, date_from: v }))} />
      </div>
      <div>
        <p className="label-xs mb-1">{t("audit.to")}</p>
        <DateInput testId="audit-to" value={filters.date_to} onChange={(v) => setFilters((f) => ({ ...f, date_to: v }))} />
      </div>
      <div className="flex items-end">
        <a href={csvUrl} target="_blank" rel="noreferrer" className="w-full" data-testid="audit-export">
          <NeuButton className="w-full">{t("audit.export")}</NeuButton>
        </a>
      </div>
    </div>
  );
};
